
import React from 'react';
import { AdminLayout } from '@/components/admin/AdminLayout';
import { CertificatesListContent } from '@/components/admin/certificates/CertificatesListContent';

export default function Certificates() {
  return (
    <AdminLayout>
      <CertificatesListContent />
    </AdminLayout>
  );
}
